import { z } from "zod";
/** AR-007 — unified output manifest across build manifest and registered artifacts. */
export const UnifiedArtifactOutputManifestV1Schema = z
    .object({
    schemaVersion: z.literal("unified-artifact-output-manifest.v1.0"),
    runId: z.string().min(1),
    projectId: z.string().min(1),
    agencyId: z.string().min(1),
    routes: z.array(z.string().min(1)),
    assets: z.array(z.string().min(1)),
    dependencies: z.array(z.string().min(1)),
    artifactNames: z.array(z.string().min(1)),
    buildManifestSchemaVersion: z.string().min(1),
})
    .strict();
export function unifyArtifactOutputManifest(buildManifest, artifacts, options) {
    return UnifiedArtifactOutputManifestV1Schema.parse({
        schemaVersion: "unified-artifact-output-manifest.v1.0",
        runId: buildManifest.runId,
        projectId: buildManifest.projectId,
        agencyId: buildManifest.agencyId,
        routes: options?.routes ?? ["/"],
        assets: options?.assets ?? [buildManifest.primaryArtifactName],
        dependencies: options?.dependencies ?? [buildManifest.recipeId],
        artifactNames: artifacts.map((row) => row.artifactName),
        buildManifestSchemaVersion: buildManifest.schemaVersion,
    });
}
//# sourceMappingURL=artifact-registry-manifest.js.map